<template>
	<div tabindex="0" @keyup.esc="closeAdd()" class="hide-outline">
		<main class="main-view">
			<div class="title" style="float: left; padding: 13px;">
				{{ getCustomer }}
			</div>
			<CreateApiKey @create="showCreate" />
			<ApiKeyList
				:apiKeys="apiKeys"
				@delete="askToDelete"
				@search="getApiKeys"
			/>
		</main>
		<CreateApiViewModal
			v-if="isCreate"
			@confirm="confirmCreate"
			@cancel="isCreate = false"
		></CreateApiViewModal>
		<DeleteModal
			v-if="showDelete"
			@confirm="deleteSelected"
			@cancel="cancelDelete"
			:message="deleteMessage"
		/>
		<ErrorModal
			v-if="displayErrorModal"
			:errors="errors"
			@closeModal="closeErrorModal"
		/>
	</div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import DeleteModal from '@/components/DeleteModal';
import ApiKeyList from './components/ApiKeyList.vue';
import ErrorModal from '@/components/ErrorModal';
import CreateApiViewModal from './CreateApiViewModal.vue';
import CreateApiKey from './components/CreateApiKey.vue';

export default {
	components: {
		ApiKeyList,
		DeleteModal,
		ErrorModal,
		CreateApiViewModal,
		CreateApiKey
	},

	data() {
		return {
			keys: [],
			showDelete: false,
			selectedApiKey: {},
			orderBys: [{ name: 'Namn', value: 'Name' }],
			errors: [],
			displayErrorModal: false,
			isCreate: false
		};
	},

	computed: {
		...mapState('apiKeyStore', ['searchParams']),
		...mapGetters('apiKeyStore', ['apiKeys', 'pagination']),
		...mapGetters('user', ['getUser', 'getUserCustomer', 'getActiveCustomer']),
		...mapGetters('appStore', ['isMobile']),

		deleteMessage() {
			return this.selectedApiKey.name
				? 'Är du säker på att du vill ta bort ?'
				: '';
		},

		getCustomer() {
			return this.getUserCustomer ? this.getUserCustomer.name : '-';
		}
	},

	watch: {
		'getActiveCustomer.id'() {
			this.searchParams.customerId = this.getUserCustomer.id;
			this.getApiKeys();
		}
	},

	methods: {
		...mapActions('apiKeyStore', [
			'getApiKeys',
			'deleteApiKey',
			'createApiKey'
		]),

		showCreate() {
			this.isCreate = !this.isCreate;
		},

		deleteSelected() {
			this.deleteApiKey(this.selectedApiKey.id);
			this.showDelete = !this.showDelete;
		},

		cancelDelete() {
			this.showDelete = !this.showDelete;
		},

		askToDelete(apiKey) {
			Object.assign(this.selectedApiKey, apiKey);
			this.showDelete = true;
		},

		search(searchValue) {
			this.searchParams.name = searchValue;
			this.getApiKeys();
		},

		orderBy(orderBy) {
			this.searchParams.orderBy = orderBy;
			this.getApiKeys();
		},

		closeErrorModal() {
			this.displayErrorModal = false;
			this.errors = [];
		},

		confirmCreate(apiKey) {
			apiKey.customerId = this.searchParams.customerId;
			this.createApiKey(apiKey);
			this.isCreate = !this.isCreate;
		}
	},

	created() {
		this.searchParams.customerId = this.getUserCustomer.id;
		this.getApiKeys();
	}
};
</script>
